// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Report_attributes_SalvarOpcaoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/report_attributes/salvar_opcao
 *
 * Returns the id of the inserted/updated report-attribute option.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Report_attributes_SalvarOpcaoResponseDados {
so_rao_id: number
}

export type Report_attributes_SalvarOpcaoResponse = ApiResponse<Report_attributes_SalvarOpcaoResponseDados>;

registerResponseContract('Report_attributes_SalvarOpcaoResponse', {
  so_rao_id: { type: 'number',  required: true },
})
